/**
 * Set localStorage
 */
 export const setStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  return window.localStorage.setItem(name, content)
}

/**
  * Get localStorage
*/
export const getStore = (name) => {
  if (!name) return
  return JSON.parse(window.localStorage.getItem(name))
}

/**
 * Remove localStorage single item
*/
export const removeItem = (name) => {
  if (!name) return
  return window.localStorage.removeItem(name)
}

/**
 * Clear localStorage
*/
export const clear = () => {
  localStorage.clear();
  sessionStorage.clear();
}

/**
 * Validate Email address
 */
export const isValidEmail = (value) => {
  return !(value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,64}$/i.test(value))
}

/**
 * Format Phone Number
 */
export const formatPhoneNumber = (value) => {
  if (!value) return
  const currentValue = value.replace(/[^\d]/g, '');
  const mobileNoLength = currentValue.length;
  if (mobileNoLength >=7) {
    if (mobileNoLength < 4) return currentValue;
    if (mobileNoLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
  } else{
    return currentValue;
  }
}
export const getErrorResponse=( errors) =>{
  
  var errorCollection = '';
  let displayError = {};
  for (var key in errors) {
     
    displayError[key] = errors[key][0];
   
    if (errors[key][0]) {
      if(errors[key][0].includes("field")){
        errorCollection = errorCollection +  key.replace(/_/g, ' ').charAt(0) + key.replace(/_/g, ' ').slice(1)  +' '+ errors[key][0].replace("This field","") + '\n'
      }else{
        errorCollection = errorCollection +  errors[key][0]+ '\n'
      }
      
    } else {
      if(typeof errors[key]=='object')
      {
         
        for (var keys in errors[key]){
          if(errors[key][keys].includes("field")){
          errorCollection = errorCollection +
            '('+[keys]+')'+
            ', '+ 
            key.replace(/_/g, ' ').charAt(0) 
            + key.replace(/_/g, ' ').slice(1) 
            +' '
            + errors[key][keys].replace("This field","") 
            + '\n'
          }else{
            errorCollection = errorCollection 
              +'('+[keys]+')'
              +', '
              +errors[key][keys] 
              + '\n'
          }
        }
      
      } 
      
    }
     
  }
  return errorCollection;
}
